import { render, staticRenderFns } from "./OurApp.vue?vue&type=template&id=e133d430&"
import script from "./OurApp.vue?vue&type=script&lang=js&"
export * from "./OurApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports